module.exports = __webpack_public_path__ + "static/media/jpg.bbc1878b.svg";